var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEroContent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    id: "svg3096",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs3093"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3217",
    style: {
      stroke: "#fff",
      strokeWidth: 0
    },
    d: "m 12,3 a 9,9 0 0 0 -9,9 9,9 0 0 0 9,9 9,9 0 0 0 9,-9 9,9 0 0 0 -9,-9 z M 8.484375,8.1914062 h 7.03125 v 1.7578126 h -4.6875 v 1.1718752 h 3.515625 v 1.757812 h -3.515625 c 0,0.781249 0.390626,1.171875 1.171875,1.171875 h 3.515625 v 1.757813 H 12 c -1.953123,0 -2.9296875,-0.976565 -2.9296875,-2.929688 H 8.484375 V 11.121094 H 9.0703125 V 9.9492188 H 8.484375 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fill: "none"
    },
    d: "m 10.828125,11.121094 h 3.515625 v 1.757812 h -3.515625 q 0,1.171875 1.171875,1.171875 h 3.515625 v 1.757813 H 12 q -2.9296875,0 -2.9296875,-2.929688 H 8.484375 V 11.121094 H 9.0703125 V 9.9492188 H 8.484375 V 8.1914063 h 7.03125 v 1.7578125 h -4.6875 z",
    id: "text1",
    "aria-label": "e"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEroContent);
export default __webpack_public_path__ + "static/media/ero-content.29a14a4d31ee1ffb01272f11cc22522c.svg";
export { ForwardRef as ReactComponent };